import { render, staticRenderFns } from "./TinymceEditor.vue?vue&type=template&id=4af57dac"
import script from "./TinymceEditor.vue?vue&type=script&lang=js"
export * from "./TinymceEditor.vue?vue&type=script&lang=js"
import style0 from "./TinymceEditor.vue?vue&type=style&index=0&id=4af57dac&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af57dac')) {
      api.createRecord('4af57dac', component.options)
    } else {
      api.reload('4af57dac', component.options)
    }
    module.hot.accept("./TinymceEditor.vue?vue&type=template&id=4af57dac", function () {
      api.rerender('4af57dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/tinymce/TinymceEditor.vue"
export default component.exports